// All images are 800x989px

import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";


const imageGalleryData01 = [
    {
        src: img1,
        title: `Metprop Solvents`,
    },
    {
        src: img2,
        title: `Metprop Solvents`
    },
    {
        src: img3,
        title: `Metprop Solvents` 
    },
];



export { imageGalleryData01 }